var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 7.05545C7.61692 7.05545 7.24952 7.20763 6.97864 7.47851C6.70775 7.7494 6.55557 8.1168 6.55557 8.49989C6.55557 8.88298 6.70775 9.25038 6.97864 9.52127C7.24952 9.79215 7.61692 9.94434 8.00001 9.94434C8.3831 9.94434 8.7505 9.79215 9.02139 9.52127C9.29228 9.25038 9.44446 8.88298 9.44446 8.49989C9.44446 8.1168 9.29228 7.7494 9.02139 7.47851C8.7505 7.20763 8.3831 7.05545 8.00001 7.05545ZM6.19296 6.69284C6.67222 6.21358 7.32224 5.94434 8.00001 5.94434C8.67779 5.94434 9.3278 6.21358 9.80706 6.69284C10.2863 7.1721 10.5556 7.82212 10.5556 8.49989C10.5556 9.17767 10.2863 9.82768 9.80706 10.3069C9.3278 10.7862 8.67779 11.0554 8.00001 11.0554C7.32224 11.0554 6.67222 10.7862 6.19296 10.3069C5.7137 9.82768 5.44446 9.17767 5.44446 8.49989C5.44446 7.82212 5.7137 7.1721 6.19296 6.69284Z",
    fill: "#4FAD5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22365 8.50005C3.05199 10.8934 5.32651 12.6112 8.00002 12.6112C10.6742 12.6112 12.9481 10.8934 13.7764 8.50005C12.9481 6.1067 10.6742 4.38894 8.00002 4.38894C5.32651 4.38894 3.05199 6.10673 2.22365 8.50005ZM1.10865 8.33361C2.02862 5.404 4.76578 3.27783 8.00002 3.27783C11.235 3.27783 13.9714 5.40403 14.8914 8.33361C14.9254 8.44196 14.9254 8.55814 14.8914 8.6665C13.9714 11.5961 11.235 13.7223 8.00002 13.7223C4.76578 13.7223 2.02862 11.5961 1.10865 8.6665C1.07462 8.55814 1.07462 8.44196 1.10865 8.33361Z",
    fill: "#4FAD5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg14);
export default __webpack_public_path__ + "static/media/svg14.b1153fd564facb4605deb93e78613220.svg";
export { ForwardRef as ReactComponent };